/**
 * Resultado da escala: "HRN 320 · Muito alto". O nível sempre sai em palavra, nunca só em cor.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import type { HrnScaleBand } from '../../../../types/machine';
import { formatHrnNumber, toneOfLevel, type HrnResultValue } from './hrnCalculation';

interface HrnResultProps {
  title: string;
  result: HrnResultValue | null;
  bands: HrnScaleBand[];
  /** O que aparece enquanto faltam respostas. */
  placeholder: string;
}

export const HrnResult: React.FC<HrnResultProps> = ({ title, result, bands, placeholder }) => {
  const tone = result ? toneOfLevel(result.level, bands) : 'default';
  const color = tone === 'default' ? 'text.primary' : `${tone}.dark`;
  return (
    <Box sx={{ border: 1, borderColor: 'divider', borderRadius: 1, p: 2 }}>
      <Typography variant="subtitle2" color="text.secondary">
        {title}
      </Typography>
      <Typography role="status" aria-live="polite" variant="h5" fontWeight={700} sx={{ color, mt: 0.5 }}>
        {result ? `HRN ${formatHrnNumber(result.hrn)} · ${result.level}` : placeholder}
      </Typography>
    </Box>
  );
};

export default HrnResult;
